import { render, staticRenderFns } from "./PlaybackInsightChrome.vue?vue&type=template&id=35b08f03&scoped=true&"
import script from "./PlaybackInsightChrome.vue?vue&type=script&lang=js&"
export * from "./PlaybackInsightChrome.vue?vue&type=script&lang=js&"
import style0 from "./PlaybackInsightChrome.vue?vue&type=style&index=0&id=35b08f03&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35b08f03",
  null
  
)

export default component.exports